import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { MysqlAdditionalPropertiesKeyType, SSLMode } from 'app/registries/consts/mysql-consts';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { ParameterConfig } from 'shell-models-lib';
import { LinkedServiceUtils } from './linked-service.utils';

@Metamodel.model({
    name: 'MySql',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.MySql_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.MySql_DisplayText)
    ]
})
export class MySqlLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly SERVER_NAME: IAttribute;
    public static readonly DATABASE_NAME: IAttribute;
    public static readonly PORT: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSWORD: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName,
        association: 'SERVER_NAME',
        templatable: true
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName,
        association: 'DATABASE_NAME',
        templatable: true
    })
    public database?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port,
        association: 'PORT',
        templatable: true,
        accepts: ['String', 'Int']
    })
    public port?: number = 3306;

    @Metamodel.attribute({
        display: stringResources.Schema
    })
    public schema?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public username?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public password?: string | AzureKeyVault;

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    public sslMode?: SSLMode = SSLMode.Preferred;
    public useSystemTrustStore?: boolean = false;
    @Metamodel.attribute({
        display: stringResources.DriverVersion,
    })
    public driverVersion?: string = driverVersions.v2;

    public override parameterizableAdditionalFields: Array<ParameterConfig<MysqlAdditionalPropertiesKeyType>>;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): MySqlLinkedService {
        return LinkedServiceUtils.commonV1ToV2(context, this, 'driverVersion') as MySqlLinkedService;
    }
}
